export default "/images/vendor/flag-icons/flags/4x3/ru.svg?7e04b988972d41f5c36902a31b818119";